"use client";

import { Link } from "@/components/common/Link";
export default function TechnicalMethodology() {
  return <section data-section-id="2520" id="internalcontaminationproblem" className="bg-gray-100 text-foreground relative w-full min-h-screen overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-screen">
        {}
        <div className="relative w-full lg:w-1/2 flex items-center px-6 sm:px-10 lg:px-16 xl:px-20 py-32">
          {}
          <div className="absolute left-0 top-0 bottom-0 w-12 hidden lg:flex flex-col items-center py-10 border-r border-border/50">
            {[...Array(20)].map((_, i) => <div key={i} data-index={i} className="flex flex-col items-center gap-4 mb-4">
                <div className="w-3 h-px bg-accent/40" />
                <div className="w-1.5 h-px bg-accent/20" />
                <div className="w-1.5 h-px bg-accent/20" />
              </div>)}
            <div className="absolute bottom-10 rotate-90 origin-center font-mono text-[9px] tracking-widest text-accent uppercase whitespace-nowrap">
              SCALE_REF_02
            </div>
          </div>

          {}
          <div className="absolute top-6 left-6 lg:left-16 flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] text-secondary uppercase">
            <span className="inline-block w-3 h-px bg-primary" />
            <span>FILE 02 / METODO.AERA</span>
          </div>
          <div className="absolute bottom-6 left-6 lg:left-16 font-mono text-[10px] tracking-[0.2em] text-secondary uppercase">
            §02 — METODOLOGIA TECNICA
          </div>

          <div className="relative w-full max-w-2xl lg:pl-8">
            <div className="font-mono text-xs sm:text-sm tracking-[0.25em] text-secondary uppercase mb-8 lg:mb-10">
              § DIVISIONE / METODO OPERATIVO
            </div>

            <h2 className="font-sans font-normal text-secondary mb-8 lg:mb-10" style={{
            fontSize: "1.125rem",
            lineHeight: "1.5"
          }}>
              Il vero problema è dentro i tubi
            </h2>

            <div className="space-y-6 text-[16px] leading-[1.7] text-muted-foreground max-w-xl">
              <p>
                Nelle cucine professionali, la cappa visibile è solo la punta dell'iceberg. Il grasso, gli oli e i vapori condensati non restano solo sui filtri, ma vengono aspirati in profondità, depositandosi all'interno di canalizzazioni che possono svilupparsi per decine di metri.
              </p>
              <p>
                Questi depositi interni, spesso situati in curve, tratti verticali e plenum difficili da raggiungere, rappresentano il vero rischio per la sicurezza e l'efficienza. Un intervento limitato alla sola superficie esterna o ai filtri non risolve il problema della contaminazione interna.
              </p>
              <p>
                Poiché un condotto lungo non può essere trattato correttamente in modo manuale dall'esterno, Aera utilizza robot e attrezzature tecniche dedicate. I nostri sistemi avanzano all'interno della canalizzazione, permettendo una bonifica integrale di tubi, condotti, ventilatori e ogni componente collegato, garantendo il ripristino delle condizioni igienico-funzionali ottimali.
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="relative w-full lg:w-1/2 min-h-[60vh] lg:min-h-screen bg-secondary/5">
          {}
          <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'radial-gradient(circle, #1F6F78 1px, transparent 1px)',
          backgroundSize: '32px 32px'
        }} />
          
          {}
          <div className="absolute inset-0 flex items-center justify-center p-12">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/ChatGPT Image 30 giu 2026, 16_40_53.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/ChatGPT Image 30 giu 2026, 16_40_53.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/ChatGPT Image 30 giu 2026, 16_40_53.png-wvc-sizes" alt="Technical hood inspection and system overview" className="w-full h-full object-cover shadow-xl" loading="lazy" decoding="async" />
          </div>

          {}
          <div className="absolute top-0 left-0 right-0 z-20 flex items-center justify-end gap-3 px-6 sm:px-8 pt-5">
            <span className="inline-block h-2 w-px bg-accent" />
            <span className="inline-block h-3 w-px bg-accent" />
            <span className="inline-block h-2 w-px bg-accent" />
          </div>

          <div className="hidden lg:flex absolute top-1/2 left-4 -translate-y-1/2 -rotate-90 origin-center font-mono text-[10px] tracking-[0.35em] text-secondary/60 uppercase whitespace-nowrap">
            PROTOCOLLO / ISPEZIONE TECNICA
          </div>

          <div className="absolute top-5 left-6 sm:left-8 font-mono text-[10px] tracking-[0.25em] text-secondary/80 uppercase">
            <span className="text-accent">●</span> ANALISI / ATTIVA
          </div>

          <div className="absolute bottom-6 right-6 sm:bottom-8 sm:right-8 z-10 text-right">
            <div className="font-mono text-[10px] tracking-[0.25em] text-secondary/60 uppercase mb-1">
              CERTIFICAZIONE
            </div>
            <div className="font-mono text-xs sm:text-sm tracking-[0.15em] text-secondary">
              NORMA UNI 10339
            </div>
            <div className="font-mono text-xs sm:text-sm tracking-[0.15em] text-secondary">
              STANDARD NADCA
            </div>
          </div>

          <div className="absolute inset-0 pointer-events-none border-l border-border lg:border-l hidden lg:block" />
        </div>
      </div>
    </section>;
}